import Modal from "@mui/material/Modal";
import Box from '@mui/material/Box';

export default function AnnouncementModal({openModal, setOpenModal}) {

    const style = (theme) => ({
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        border: 'none',
        boxShadow: 24,
        borderRadius: '10px',
        maxHeight: "500px",
        overflowY:"scroll",
        "::-webkit-scrollbar": {
            width: "6px",
            height: "0px",
        },
        "::-webkit-scrollbar-track": {
            background: "#f1f1f1",
            borderRadius: 20

        },
        "::-webkit-scrollbar-thumb": {
            background: "#044448",
            borderRadius: "15px"
        },
        "::-webkit-scrollbar-thumb:hover": {
            background: "#555"
        },
        [theme.breakpoints.down('md')]: {
            width: "80%",
        },
    })

    const notes = [
        {
            header: "۱. پس زمینه ساده و نور کافی",
            rules: [
                "پس زمینه ویدیو ساده و ترجیحا سفید باشد",
                "نور محیط باید به اندازه باشد و محیط تاریک نباشد"
            ]
        },
        {
            header: "۲. تصویر و صدا واضح",
            rules: [
                "تصویر شما بطور کامل در کادر و واضح باشد",
                "شدت صدا و بیان کلمات باید واضح و قابل تشخیص و محیط اطراف ساکت باشد"
            ]
        },
        {
            header: "۳. نکات ظاهری",
            rules: [
                "تصویر شما نباید تفاوت بسیار زیاد با تصویر کارت ملی شما داشته باشد",
                "بطور مثال اگر در تصویر کارت ملی عینک ندارید، عینک نزنید",
                "ضمن رعایت شئونات اسلامی، جهت جلوگیری از خطا از آرایش اجتناب کنید"
            ]
        },
        {
            header: "۴. فعال نمودن دوربین",
            rules: [
                "درخواست مجوز دوربین توسط مرورگر خود را تایید کنید",
                "اگر سیستمی که با ان به سامانه وارد شده اید دسترسی به دوربین ندارد، می توانید از یک سیستم دیگر وارد سامانه شوید و احراز هویت خود را انجام دهید. اطلاعات شما تا این مرحله در سامانه ما ذخیره شده است."
            ]
        },
    ]


    return(
        <Modal
            open={openModal}
        >
            <Box sx={style} className="rule-width p-4">

                <div>
                    <p className="mb-1 p-0" style={{fontSize: "1rem", fontWeight: "800"}}>نکات مهم در مورد ویدیو احراز هویت تصویری</p>
                    <p className="show-info-text p-0">لطفا نکات زیر را هنگام گرفتن ویدیو رعایت کنید</p>
                </div>

                {
                    notes.map( (row, index) => (
                        <div key={index} style={{border: "1px solid #cfd2d5ba", borderRadius: "10px", padding: "1rem", marginTop: "1rem"}}>
                            <p className="mb-1 p-0" style={{fontSize: "1rem", fontWeight: "800", color: "#044448"}}>{row.header}</p>
                            <ul className={`annModal`}>
                                {
                                    row.rules.map( (rule, keyIndex) => (
                                        <li className={`mt-2`} key={index+keyIndex}>{rule}</li>
                                    ))
                                }
                            </ul>
                        </div>
                    ))
                }

                <p className="annModalFooter p-0">اگر با مشکلی روبرو هستید میتوانید با پشتیبانی تماس بگیرید</p>

                <div className={`d-flex justify-content-center`}>
                    <button
                        className='btn text-form-button'
                        style={{"background" : "#044448", "padding": "1.5% 13%"}}
                        onClick={() => setOpenModal(false)}
                    >متوجه شدم</button>
                </div>

            </Box>
        </Modal>
    )
}